module.exports = __webpack_public_path__ + "static/media/signup-homeowner.74ed3c7f.webp";